var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "140px",
    viewBox: "0 0 32.00 32.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.128
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_3111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7627 20.1418C23.7627 20.1418 25.5627 27.4428 26.0827 29.4318C26.5727 31.3018 25.0727 31.2518 24.1527 30.6128C23.1227 29.8918 16.0027 24.8018 16.0027 24.8018C16.0027 24.8018 8.82267 29.9318 7.83267 30.6218C6.98267 31.2118 5.40267 31.3418 6.04267 29.4528C6.50267 27.8628 8.75267 20.1418 8.75267 20.1418C8.75267 20.1418 2.18267 15.3318 1.48267 14.7918C0.782673 14.2618 0.752673 12.7618 2.01267 12.6528C3.26267 12.5518 11.3427 11.8628 11.3427 11.8628C11.3427 11.8628 14.4727 3.19282 14.8927 2.04182C15.3027 0.671824 16.6627 0.641824 17.2127 2.02182C17.6627 3.14182 21.1727 11.8628 21.1727 11.8628C21.1727 11.8628 28.8027 12.5418 29.9527 12.6418C31.2127 12.7218 31.3127 14.2828 30.4927 14.9128C29.6827 15.5518 23.7627 20.1418 23.7627 20.1418Z",
    fill: "#FFCB05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2162 2.02159C17.6662 3.14259 21.1742 11.8636 21.1742 11.8636C21.1742 11.8636 28.8062 12.5426 29.9552 12.6386C31.2142 12.7186 31.3132 14.2796 30.4962 14.9146C29.6812 15.5466 23.7612 20.1406 23.7612 20.1406C23.7612 20.1406 25.5602 27.4376 26.0832 29.4256C26.5732 31.2986 25.0702 31.2486 24.1562 30.6096C23.1212 29.8886 16.0012 24.7966 16.0012 24.7966C16.0012 24.7966 8.8252 29.9276 7.8372 30.6176C6.9872 31.2086 5.4002 31.3376 6.0402 29.4536C6.5052 27.8636 8.7552 20.1406 8.7552 20.1406C8.7552 20.1406 2.1792 15.3286 1.4812 14.7916C0.7792 14.2556 0.7572 12.7596 2.0092 12.6526C3.2632 12.5466 11.3432 11.8636 11.3432 11.8636C11.3432 11.8636 14.4752 3.18959 14.8962 2.04259C15.3042 0.671592 16.6632 0.640592 17.2162 2.02159Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_3111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.ff16dd58757a4e4096740f60ea234d3e.svg";
export { ForwardRef as ReactComponent };